import { createRouter, createWebHistory } from 'vue-router'
import ListView from '@/views/ListView'
import DetailView from '@/views/DetailView'
import store from '@/store'
import DarmasApiService from '@/services/DarmasApiService'

const routes = [
	{
		path: '/',
		alias: ['/details', '/details/'],
		name: 'List',
		component: ListView,
		props: true,
		meta: {
			title: 'Lade Fahrzeugmarkt',
			headerTitle: 'Fahrzeugmarkt',
			transition: 'slide-left',
		},
	},
	{
		path: '/details/:id',
		name: 'Details',
		component: DetailView,
		props: true,
		meta: {
			title: 'Fahrzeugdetails',
			headerTitle: 'Fahrzeugdetails',
			transition: 'slide-right',
			scrollToTop: true,
		},
	},
]

let historyMode = createWebHistory()

const router = createRouter({
	history: historyMode,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.name === 'Details') {
			window.scrollTo(0, 0)
		} else {
			return savedPosition
		}
	},
})

router.beforeEach((to, from, next) => {
	if (to.name === 'List') {
		const docTitle = to.meta.headerTitle + ' | Seite ' + store.state.pageNum
		DarmasApiService.setMetaData(docTitle, to.meta.headerTitle)
	} else {
		DarmasApiService.setMetaData('Fahrzeug', 'Lade Fahrzeug...')
	}
	next()
})

router.afterEach((to, from) => {
	if (from.name === 'Details') {
		let filterUrl = DarmasApiService.decodeFiltersFromStateToUrl()
		if (filterUrl.length > 3 || DarmasApiService.filtersActive()) {
			let pushUrl = '?' + filterUrl.slice(1)
			window.history.pushState('', '', pushUrl)
		} else {
			window.history.pushState('', '', '')
		}
	}
})

export default router
